import { DatasetType, ObjectDataset, OnlineStorage, RawTextDataset } from "@tblabs/storage";
import { Line, MultilineInput, RefString, Snack, Span } from "@tblabs/truffle";
import { JsonEditor } from "../Components/JsonEditor";
import { Panel } from "../Components/Panel";
import { PrimaryButton } from "../Components/PrimaryButton";
import { Page } from "./Page";
import { Bold } from "../Components/Bold";


export class DatasetItemEditPage extends Page
{
    constructor(private _storage: OnlineStorage, private datasetName: string, private itemId: string)
    {
        super(`Item edit`);

        this.Content(async (body) =>
        {
            const metadata = await this._storage.GetDatasetMetadata(this.datasetName);

            switch (metadata.Type)
            {
                case DatasetType.Picture:
                    body.Append(
                        new Span("There is no way to edit pictures. Delete and add new one instead."),
                    );
                    return;

                case DatasetType.File:

                    body.Append(
                        new Span("There is no way to edit files. Delete and add new one instead."),
                    );
                    return;

                case DatasetType.Object:
                    {
                        const dataset = this._storage.GetObjectDataset(this.datasetName);
                        const item = await dataset.GetOne(this.itemId);

                        const itemAsString = new RefString(JSON.stringify(item, null, 2));

                        body.Append(
                            new Panel(["Item ", new Bold(this.itemId.toUpperCase()), " edit"], [
                                "Of ", new Bold(DatasetType.Object), " type in ", new Bold(this.datasetName), " dataset",
                                new Line(),
                                new PrimaryButton("Save").OnClick(async () => this.SaveObject(dataset, itemAsString)),
                            ]),
                            new Panel("Content to edit", [
                                new JsonEditor(itemAsString),
                            ])
                        );
                    }
                    return;

                case DatasetType.Text:
                    {
                        const dataset = this._storage.GetTextDataset(this.datasetName);
                        const item = await dataset.Read(this.itemId);

                        const itemAsString = new RefString(item.join("\n"));

                        body.Append(
                            new Panel(["Item ", new Bold(this.itemId.toUpperCase()), " edit"], [
                                "Of ", new Bold(DatasetType.Text), " type in ", new Bold(this.datasetName), " dataset",
                                new Line(),
                                new PrimaryButton("Save").OnClick(async () => this.SaveText(dataset, itemAsString)),
                            ]),
                            new Panel("Content to edit", [
                                new MultilineInput(itemAsString).Rows(32),
                            ])
                        );
                    }
                    return;

                default:
                    throw new Error(`Unknown dataset type: ${type}`);
            }
        });
    }

    private async SaveObject(dataset: ObjectDataset<any>, itemAsString: RefString): Promise<void>
    {
        try
        {
            const item = JSON.parse(itemAsString.value);

            await dataset.Update(this.itemId, item);

            new Snack("Item saved");
        }
        catch (ex: any)
        {
            new Snack("Failed to save item", ex.message, { autoCloseTimeout: 15000 });
        }
    }

    private async SaveText(dataset: RawTextDataset, itemAsString: RefString): Promise<void>
    {
        try
        {
            const item = itemAsString.value;

            await dataset.ReplaceText(this.itemId, item);

            new Snack("Item saved");
        }
        catch (ex: any)
        {
            new Snack("Failed to save item", ex.message, { autoCloseTimeout: 15000 });
        }
    }
}
